import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "partners" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, " Nos partenaires ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Location-gardemeuble.fr a été choisi comme partenaire privilégié par les grandes marques. Nous aimons nos partenaires ! ", -1)
const _hoisted_4 = { class: "partner-row" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"1em"} }, [
  /*#__PURE__*/_createElementVNode("h3", null, " Partenaires avec Location-gardemeuble.fr "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Imaginez votre logo sur cette page ? Il y a beaucoup de bonnes raisons de devenir partenaires de Location-gardemeuble.fr. Pour commencer, vous pouvez profiter d’un accès immédiat à notre plate-forme, la plus grande de l’industrie du stockage. Nous pouvons également vous faire profiter de nos clients en leur proposant vos services, compatibles avec les nôtres. Nous sommes ouverts à de multiples possibilités de partenariats qui pourront profiter à nos clients. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Merci de votre intérêt avec Location-gardemeuble.fr ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.partners, (partner) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: partner.img.replace('https://www.location-', 'https://api.location-'),
                alt: partner.name,
                width: "250",
                height: "110"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", null, _toDisplayString(partner.name), 1),
              _createElementVNode("p", {
                innerHTML: _ctx.linksNofollow( partner.description )
              }, null, 8, _hoisted_6)
            ])
          ]))
        }), 256))
      ]),
      _hoisted_7
    ]),
    _createVNode(_component_Footer)
  ]))
}